import { PriceFileConfig } from './price-file-config';

export const defaultPriceFileConfig: PriceFileConfig = {
  priceFile: {
    priceFileStatusInitialDelay: 10,
    priceFileStatusInterval: 120,
  },
};
